import { createFileRoute } from '@tanstack/react-router'

import { SignInPage } from '@/features/identity/SignInPage'

export const Route = createFileRoute('/signin/')({
  component: SignInRoute,
  /**
   * Where the gate said somebody was headed, carried verbatim.
   *
   * Not validated here beyond its type: what counts as an address worth
   * honouring is a question about where this application will send people, and
   * it is answered in one place, by `destinationFrom`, rather than half here
   * and half there.
   */
  validateSearch: (search: Record<string, unknown>): { redirect?: string | undefined } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
})

function SignInRoute() {
  const { redirect } = Route.useSearch()

  return <SignInPage redirect={redirect} />
}
